export default {
  computed: {
    isSpecial() {
      return this.type === 'SPECIAL';
    },
    isVendor() {
      return this.type === 'VENDOR';
    },
  },
}
